import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignIn } from '@fortawesome/free-solid-svg-icons/faSignIn';
import { faSignOut } from '@fortawesome/free-solid-svg-icons/faSignOut';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { faX } from '@fortawesome/free-solid-svg-icons/faX';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { detectDeviceType, handleTabAction } from '../../utils/helpers';
import { LANGUAGE_SESSION_STORAGE_KEY } from '../../utils/constants/sessionStorageConstants';
import { executeLogout, isLogoutSuccessfully } from '../../store/logoutSlice';
import { useAppDispatch } from '../../store/store';
import {
  getProfileMenuContent,
  getLanguage,
  setLanguageContent,
} from '../../store/contentSlice';
import { setLanguageForTnc } from '../../store/termsAndConditionsSlice';
import { getSelectedClientFeature } from '../../store/featureSlice';
import './profileMenu.css';

const ProfileMenuList = ({ handleProfileMenuClick, userName }: any) => {
  const { signOutButtonLabel, signInButtonLabel, toggleLanguageLabel }: any =
    useSelector(getProfileMenuContent);
  const selectedLanguage: any = useSelector(getLanguage);
  const isSessionEnded = useSelector(isLogoutSuccessfully);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const features = useSelector(getSelectedClientFeature);
  const { accessToLanguageToggle } = features.features;
  const handleLogout = (event: any) => {
    dispatch(executeLogout());
    handleProfileMenuClick(event);
    navigate('/thank-you');
  };

  const handleLogin = (event: any) => {
    handleProfileMenuClick(event);
    navigate('/welcome');
  };

  const handleLangToggle = () => {
    if (accessToLanguageToggle) {
      const setLang = selectedLanguage === 'EN' ? 'ES' : 'EN';
      sessionStorage.setItem(LANGUAGE_SESSION_STORAGE_KEY, setLang);
      dispatch(setLanguageContent(setLang));
      dispatch(setLanguageForTnc(setLang));
    }
  };

  const LanguageButton = () => {
    return (
      <a
        className="element-wrapper menu-link"
        data-reason="langaugeToggle"
        data-object="button"
        data-channel="langaugeToggle"
        data-testid="language-toggle-button"
        onClick={handleLangToggle}
      >
        <FontAwesomeIcon icon={faGlobe} className="menu-list-icon" />
        <span className="menu-element">{toggleLanguageLabel}</span>
      </a>
    );
  };

  return (
    <div className="menu">
      <ul>
        <li>
          <a className="element-wrapper menu-link mobile-profile">
            <div className="profile-icon-wrapper">
              <FontAwesomeIcon
                className="profile-icon"
                icon={faCircleUser}
                onClick={handleProfileMenuClick}
                data-type={detectDeviceType}
                data-reason="profile"
                data-object="button"
                data-channel="closeProfile"
              />
              <span className="profile-name">{userName}</span>
              <FontAwesomeIcon
                className="close-icon"
                icon={faX}
                onClick={handleProfileMenuClick}
                data-type={detectDeviceType}
                data-reason="Profile"
                data-object="button"
                data-channel="closeProfile"
              />
            </div>
          </a>
          {accessToLanguageToggle && <LanguageButton />}
          {isSessionEnded ? (
            <>
              <a
                className="element-wrapper menu-link"
                onClick={handleLogin}
                data-testid="log-in-button"
                data-type={detectDeviceType}
                data-reason="Profile"
                data-object="button"
                data-channel="signInProfile"
              >
                <FontAwesomeIcon
                  className="sign-in-out-icon menu-list-icon"
                  icon={faSignIn}
                />
                <span className="menu-element">{signInButtonLabel}</span>
              </a>
              {accessToLanguageToggle && <LanguageButton />}
            </>
          ) : (
            <>
              <a
                className="element-wrapper menu-link"
                onClick={handleLogout}
                data-testid="logout-button"
                data-type={detectDeviceType}
                data-reason="Profile"
                data-object="button"
                data-channel="signOutProfile"
              >
                <FontAwesomeIcon
                  className="sign-in-out-icon menu-list-icon"
                  icon={faSignOut}
                />
                <span
                  className="menu-element"
                  tabIndex={0}
                  onKeyDown={(e) => handleTabAction(e, handleLogout)}
                >
                  {signOutButtonLabel}
                </span>
              </a>
            </>
          )}
        </li>
      </ul>
    </div>
  );
};

export default ProfileMenuList;
